<template>
<div>
  <div class="props">
    {{questions}}
    {{base_filters}}
    {{tree_id}}
  </div>
  <trees-question-vue
    v-for="question in questions"
    @question_answer="question_answer"
    @question_back="question_back"
    v-bind:key="question.id">
  </trees-question-vue>
</div>
</template>

<script>
import Question from 'components/trees/Question.vue'

export default {
  props: ['questions', 'base_filters', 'tree_id'],
  components: {
    'trees-question-vue': Question
  },
  methods: {
    question_answer: function(index) {
      this.$http.post('trees/questions', {tree_id: this.tree_id, path_answers_attributes: this.path_answers(), base_filters: this.base_filters}).
        then(
          response => {
            if (response.data.name) {
              var last_question = this.questions[this.questions.length - 1]
              response.data.id = this.questions.length
              response.data.targets['-1'] = last_question.targets[last_question.answer.value]
              this.$emit('update:questions', this.questions.concat(response.data))
            } else {
              alert('Has llegado al final')
            }
          },
          error => {console.log(error)})
    },
    question_back: function(index) {
      this.$emit('update:questions', this.questions.slice(0,index+1))
    },
    path_answers: function() {
      return this.questions.map(function(question) {
        return {name: question.name, value: question.value, answer: question.answer.value}
      })
    }
  }
}
</script>

<style scoped>

</style>
